import { useState, useEffect, useCallback } from 'react'

export const OPEN_COMMAND_PALETTE_EVENT = 'open-command-palette'

export const useCommandPalette = () => {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        e.stopPropagation()
        setIsOpen(prev => !prev)
      }
    }

    const handleOpenEvent = () => setIsOpen(true)

    document.addEventListener('keydown', handleKeyDown, true)
    document.addEventListener(OPEN_COMMAND_PALETTE_EVENT, handleOpenEvent)

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true)
      document.removeEventListener(OPEN_COMMAND_PALETTE_EVENT, handleOpenEvent)
    }
  }, [])

  return { isOpen, open, close }
}
